import "./App.css";

import { useEffect, useRef, useState } from "react";
import { Routes, Route, Link, useNavigate } from "react-router-dom";

import Header from "./Components/Header";
import MenuContainer from "./Components/MenuContainer";
import {
  AccountBalanceWalletRounded,
  Chat,
  Favorite,
  HomeRounded,
  Settings,
  SummarizeRounded,
} from "@mui/icons-material";
import BannerName from "./Components/BannerName";
import MenuCard from "./Components/MenuCard";
import { MenuItems, Items } from "./Components/Data";
import ItemCard from "./Components/ItemCard";
import DebitCard from "./Components/DebitCard";
import SubMenuContainer from "./Components/SubMenuContainer";
import ShippingAddressScreen from "./Components/ShippingAddressScreen";
import CartItem from "./Components/CartItem";
import { useStateValue } from "./Components/StateProvider";

function App() {
  const [isMainData, setMainData] = useState(
    Items.filter((element) => element.itemId == "buger01")
  );

  const [{ cart, total }, dispatch] = useStateValue();
  const [totalPrice, setTotalPrice] = useState(0);
  const [myTotal,setMyTotal]= useState(0);
  const [showShippingAddress, setShowShippingAddress]=useState(false);

  useEffect(()=>{
    let t=0;
    const prices = document.querySelectorAll(".itemPriceValue");
    prices.forEach(n=>t+=+(n.innerHTML));
    setMyTotal(t);
    
  })

  useEffect(() => {
    const menuLi = document.querySelectorAll("#menu li");
    

    function setMenuActive() {
      menuLi.forEach((n) => n.classList.remove("active"));
      this.classList.add("active");
    }

    menuLi.forEach((n) => n.addEventListener("click", setMenuActive));

    // menu Card active class changer
    const menuCard = document
      .querySelector(".rowContainer")
      .querySelectorAll(".rowMenuCard");

    function setMenuCardActive() {
      menuCard.forEach((n) => n.classList.remove("active"));
      this.classList.add("active");
    }

    menuCard.forEach((n) => n.addEventListener("click", setMenuCardActive));
  }, [isMainData, cart, total, totalPrice]);

  const setData = (itemId) => {
    setMainData(Items.filter((element) => element.itemId == itemId));
  };

  

  const Main=()=>(<>
  
<main>
  <div className="mainContainer">
    {/* Banner  */}
    <div className="banner">
      <BannerName name={"Customer"} discount={"20"} more={"#"} />
      <img
        src="https://firebasestorage.googleapis.com/v0/b/food-delivery-37c59.appspot.com/o/Images%2Fdelivery.png?alt=media&token=69b9823d-96df-452a-bd4e-14d27a4cc337"
        alt=""
        className="deliveryPic"
      />
    </div>

    <div className="dishContainer">
      <div className="menuCard">
        <SubMenuContainer />
      </div>

      <div className="rowContainer">
        {MenuItems &&
          MenuItems.map((data) => (
            <div key={data.id} onClick={() => setData(data.itemId)}>
              <MenuCard
                imgSrc={data.imgSrc}
                name={data.name}
                isActive={data.id == "1" ? true : false}
              />
            </div>
          ))}
      </div>

      <div className="dishItemContainer">
        {isMainData &&
          isMainData.map((data) => (
            <ItemCard
              key={data.id}
              itemId={data.id}
              imgSrc={data.imgSrc}
              name={data.name}
              ratings={data.ratings}
              price={data.price}
            />
          ))}
      </div>
    </div>
  </div>
  <div className="rightMenu">
    <div className="debitCardContainer">
      <div className="debitCard">
        <DebitCard />
      </div>
    </div>

    {!cart ? (
      <div className="addSomeItem">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/food-delivery-37c59.appspot.com/o/Images%2FemptyCart.png?alt=media&token=50b733d4-cdd9-4025-bffe-8efa4066ca24"
          alt=""
          className="emptyCart"
        />
      </div>
    ) : (
      <div className="cartCheckOutContianer">
        <div className="cartContainer">
          <SubMenuContainer />

          <div className="cartItems">
            {cart &&
              cart.map((data) => (
                <CartItem
                  key={data.id}
                  itemId={data.id}
                  name={data.name}
                  imgSrc={data.imgSrc}
                  qty={"4"}
                  price={data.price}
                />
              ))}
          </div>
        </div>
        <div className="totalSection">
          <h3>Total</h3>
          <p>
            <span>₦</span> {myTotal}
          </p>
        </div>
        <button className="checkOut" ><Link to="/shipping">Check out</Link></button>
      </div>
    )}
  </div>
</main>
  </>)

  return (
    <div className="App">
      {/* Header section */}
      <Header />

      {/* Left menu */}
      <div className="leftMenu">
        <ul id="menu">
          {/* prettier-ignore */}
          <MenuContainer link = {'#'} icon = {<HomeRounded />}  isHome/>
          {/* prettier-ignore */}
          <MenuContainer link = {'#'} icon = {<Chat />}  />
          {/* prettier-ignore */}
          <MenuContainer link = {'#'} icon = {<AccountBalanceWalletRounded />}  />
          {/* prettier-ignore */}
          <MenuContainer link = {'#'} icon = {<Favorite />} />
          {/* prettier-ignore */}
          <MenuContainer link = {'#'} icon = {<SummarizeRounded />}  />
          {/* prettier-ignore */}
          <MenuContainer link = {'#'} icon = {<Settings />}  />
          <div className="indicator"></div>
        </ul>
      </div>
      <Routes>
        <Route path="/" element={<Main/>} />
        <Route path="/shipping" element={<ShippingAddressScreen totalPrice={myTotal}/>} />
      </Routes>
      
    </div>
  );
}

export default App;
